// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { Bar, Doughnut } from 'react-chartjs-2';
import {
  ArcElement,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Tooltip,
} from 'chart.js';

ChartJS.register(ArcElement, BarElement, CategoryScale, LinearScale, Tooltip, Legend);

function useBackofficeDarkMode() {
  const [darkMode, setDarkMode] = useState(
    () => document.documentElement.dataset.backofficeTheme === 'dark',
  );

  useEffect(() => {
    const updateTheme = () => setDarkMode(
      document.documentElement.dataset.backofficeTheme === 'dark',
    );
    const observer = new MutationObserver(updateTheme);

    updateTheme();
    window.addEventListener('backoffice-theme-changed', updateTheme);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-backoffice-theme'],
    });

    return () => {
      observer.disconnect();
      window.removeEventListener('backoffice-theme-changed', updateTheme);
    };
  }, []);

  return darkMode;
}

const commonOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { display: false },
    tooltip: { backgroundColor: '#0f3f3b', padding: 12, cornerRadius: 10 },
  },
};

export function ActivityBarChart({ labels = [], values = [], label = 'Respostas' }) {
  const darkMode = useBackofficeDarkMode();
  const hasData = values.some((value) => Number(value) > 0);
  if (!hasData) return <EmptyChart message="A atividade aparecerá aqui quando chegarem as primeiras respostas." />;
  return (
    <div className="h-64">
      <Bar
        key={darkMode ? 'activity-dark' : 'activity-light'}
        data={{
          labels,
          datasets: [{ label, data: values, backgroundColor: '#0f766e', hoverBackgroundColor: '#0b5f59', borderRadius: 8, borderSkipped: false, maxBarThickness: 42 }],
        }}
        options={{
          ...commonOptions,
          scales: {
            x: {
              border: { color: darkMode ? '#53706a' : '#cbd5e1' },
              grid: { display: false },
              ticks: {
                color: darkMode ? '#e5f0ee' : '#475569',
                font: { size: 13, weight: 600 },
                padding: 8,
                maxRotation: 50,
                minRotation: 50,
              },
            },
            y: {
              beginAtZero: true,
              border: { color: darkMode ? '#53706a' : '#cbd5e1' },
              ticks: {
                precision: 0,
                color: darkMode ? '#e5f0ee' : '#475569',
                font: { size: 13, weight: 600 },
                padding: 8,
              },
              grid: { color: darkMode ? 'rgba(105, 139, 132, .38)' : '#e2e8f0' },
            },
          },
        }}
      />
    </div>
  );
}

export function StatusDoughnutChart({ labels = [], values = [], colors = ['#10b981', '#f59e0b', '#cbd5e1'] }) {
  useBackofficeDarkMode();
  const total = values.reduce((sum, value) => sum + Number(value || 0), 0);
  if (!total) return <EmptyChart message="Ainda não existem estados de pagamento para analisar." />;
  return (
    <div className="grid items-center gap-5 sm:grid-cols-[180px_1fr]">
      <div className="relative h-44">
        <Doughnut data={{ labels, datasets: [{ data: values, backgroundColor: colors, borderWidth: 0, hoverOffset: 4 }] }} options={{ ...commonOptions, cutout: '72%' }} />
        <div className="pointer-events-none absolute inset-0 flex flex-col items-center justify-center">
          <strong className="text-2xl text-slate-950">{total}</strong>
          <span className="text-xs text-slate-500">total</span>
        </div>
      </div>
      <div className="space-y-3">
        {labels.map((item, index) => (
          <div key={item} className="flex items-center justify-between gap-4 text-sm">
            <span className="flex items-center gap-2 text-slate-600"><i className="h-2.5 w-2.5 rounded-full" style={{ backgroundColor: colors[index] }} />{item}</span>
            <strong className="text-slate-900">{values[index] || 0}</strong>
          </div>
        ))}
      </div>
    </div>
  );
}

function EmptyChart({ message }) {
  return <div className="flex h-64 items-center justify-center rounded-2xl border border-dashed border-slate-200 bg-slate-50 px-6 text-center text-sm leading-6 text-slate-500">{message}</div>;
}
